import { render, staticRenderFns } from "./Foot1425-H.vue?vue&type=template&id=798142e8"
import script from "./Foot1425-H.vue?vue&type=script&lang=js"
export * from "./Foot1425-H.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports